export default __webpack_public_path__ + "static/media/4.d859d829.svg";